module.exports = __webpack_public_path__ + "static/img/14000792.d4db1230.png";